import { NotFound } from '@features/NotFound'
import { createFileRoute } from '@tanstack/react-router'
import { Suspense } from 'react'

export const Route = createFileRoute('/catchAll')({
  component: () => (
    <Suspense fallback={<div>Loading...</div>}>
      <NotFound />
    </Suspense>
  ),
})
